<template>
  <div class="unassigned-commitment-list">
    <!--
    <h5 class="mb-2 mt-3">Unassigned commitments</h5>
    -->
    <draggable
      class="timeslot-collection-draggable"
      v-model="draggablesList"
      :swapThreshold="0.25"
      group="commitment-shared"
      draggable=".commitment-draggable">

    <!-- INCLUDE: DragListCommiements -->
    <div
      v-for="commitment in draggablesList"
      :key="commitment.$id"
      class="commitment-draggable mb-1 p-1">
      <InlineCommitment
        :goal-id="commitment.goalId"
        :commitment-id="commitment.$id"
        :active="commitment.active"
        :selected="get_effort_selected === commitment.$id"
        @select="SET_ACTIVE_EFFORT" />
    </div>

    <!-- <div v-if="related_commitments.length === 0" class="timeslot-collection__unassigned">
      <i class="el-icon-error" style="color: #c0c4cc"></i> No unassigned commitments.
    </div> -->

    </draggable>
    <!-- <pre class="mini-pre">{{related_commitments.map(item => item.user.prioidx + ':' + item.meta.name )}}</pre> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import InlineCommitment from '@/components/Inline/InlineCommitmentWithProgress';
import DraggablesMixin from './DraggablesMixin'
import Draggable from 'vuedraggable';

export default {
  mixins: [ DraggablesMixin ],
  props: {
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters('calendar',[
      "get_effort_selected"
    ]),
  },
  methods: {
    ...mapMutations('calendar', [
      'SET_ACTIVE_EFFORT'
    ]),
  },
  components: {
    InlineCommitment,
    Draggable,
  }
}
</script>

<style>
</style>
